module.exports = "/_next/static/images/febc101f02e0cc4f93663cbbd144d2fa-left-side-desktop.jpg.webp";